import mapReducer from './map.slice';

export * from './map.thunk';
export * from './map.slice';

export default mapReducer;
